import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { baseurl } from '../Baseurl';
import slugify from 'slugify';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import p1 from "../components/img/p1.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import Select from 'react-select'; 
import { Calendar, Filter, Search } from 'react-feather';
import { useNavigate } from "react-router-dom";
import HomeTabs from '../pages/HomeTabs'; 
import UserTabMenu from './UserTabMenu';


const options = [
  { value: "", label: "Filter" },
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
];

const columnColors = {
  'To Do': '#f8d7da',        // Light Red
  'In Progress': '#fff3cd',  // Light Yellow
  'In-Review': '#d1ecf1',    // Light Cyan
  'Done': '#d4edda',         // Light Green
  'Closed': '#e2e3e5'        // Light Gray
};


export default function ProductManagement() {
  const [showForm, setShowForm] = useState(false);
  const [showClosed, setShowClosed] = useState(false);
  const [projects, setProjects] = useState([]);
const [label, setLabel] = useState('');

 const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
   useEffect(() => {
     const assignee_id = localStorage.getItem("assignee_id");
     if (!assignee_id) {
       navigate("/"); 
     }
 
     // 👇 load dark mode preference
     const savedTheme = localStorage.getItem("darkMode") === "true";
     setDarkMode(savedTheme);
     document.body.classList.toggle("dark", savedTheme);
   }, [navigate]);

   


  const [newProject, setNewProject] = useState({ title: '', description: '', label: ''  });
  const [editIndex, setEditIndex] = useState(null);
  const [editData, setEditData] = useState({ title: '', description: '', deadline: '' });

  const handleCreate = async () => {
  if (newProject.title.trim() === '') return;

  const payload = {
    title: newProject.title,
    description: newProject.description,
    label: newProject.label,
    status: 'todo', 
    assignees: JSON.stringify(selectedAssignees.map(a => a.value)),
    deadline: newProject.deadline
      ? newProject.deadline.toISOString().split("T")[0] // Send as YYYY-MM-DD
      : null,
    organization_id: localStorage.getItem('organization_id'),
    adminId: localStorage.getItem("adminID")
  };

  console.log("Sending data to backend:", payload);

  try {
    const response = await axios.post(`${baseurl}createProject`, payload);

    const createdProject = response.data;
    setProjects([...projects, createdProject]);

    
Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Project Added successfully',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      background: '#28a745',
      color: '#fff'
    });
    setNewProject({ title: '', description: '', deadline: null });
    setShowForm(false);
  } catch (error) {
    console.error("Error creating project:", error);
    Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Failed to Add project',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          background: '#dc3545',
          color: '#fff'
        });
    // alert("Failed to create project. Try again.");
  }
};



useEffect(() => {
  const fetchProjects = async () => {
    const orgId = localStorage.getItem('user_org_id');
    if (!orgId) return;

    try {
      const res = await axios.get(`${baseurl}getProjectsByOrgId/${orgId}`);
      setProjects(res.data); // Set fetched projects
    } catch (err) {
      console.error("Error fetching projects:", err);
    }
  };

  fetchProjects();
}, []);






const [assignees, setAssignees] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);

  useEffect(() => {
      const orgId = localStorage.getItem("organization_id");
      if (!orgId) return;
  
      axios.get(`${baseurl}getAssigneesByOrgId/${orgId}`)
        .then((res) => {
          if (res.data.assignees) {
            const options = res.data.assignees.map((user) => ({
              value: user.id,
              label: user.full_name
            }));
            setAssignees(options);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch assignees:", err);
        });
    }, []);


 const handleAssigneeChange = (selectedOptions) => {
    setSelectedAssignees(selectedOptions || []);
  };

 
 

const handleEdit = (index) => {
  setEditIndex(index);
  const project = projects[index];

  // Map assignees_info into react-select format
  const preselected = (project.assignees_info || []).map(a => ({
    value: a.id,
    label: a.full_name
  }));

  setSelectedAssignees(preselected);

  setEditData({
    id: project.id,
    title: project.title,
    description: project.description,
    deadline: project.deadline ? new Date(project.deadline) : null,
    label: project.label || ""
  });
};





 const handleSaveEdit = async (index) => {
  const updatedProject = {
    id: editData.id,
    title: editData.title,
    description: editData.description,
    deadline: editData.deadline,
    label: editData.label,
    assignee: selectedAssignees.map(a => a.value), // send IDs only
    adminId: localStorage.getItem("adminID")
  };

  console.log("handleSaveEdit", updatedProject);

  try {
    await axios.post(`${baseurl}updateProject/${editData.id}`, updatedProject);

    const updatedProjects = [...projects];
    updatedProjects[index] = {
      ...updatedProjects[index],
      title: editData.title,
      description: editData.description,
      label: editData.label,
      assignee: selectedAssignees.map(a => a.value)
    };

    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Project updated successfully',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      background: '#28a745',
      color: '#fff'
    });

    setProjects(updatedProjects);
    setEditIndex(null);
  } catch (error) {
    console.error("Error updating project:", error);

    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      title: 'Failed to update project',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      background: '#dc3545',
      color: '#fff'
    });
  }
};


  const renderProjectCard = (project, index) => {
    if (editIndex === index) {
      return (
        <div key={index} className="card p-3 mb-3 shadow-sm position-relative">
          <input
            type="text"
            className="form-control mb-2"
            value={editData.title}
           onChange={(e) => setEditData((prev) => ({ ...prev, title: e.target.value }))}
          />
          <textarea
            className="form-control mb-2"
            rows="3"
            value={editData.description}
           onChange={(e) => setEditData((prev) => ({ ...prev, description: e.target.value }))}
          ></textarea>


         {/* Label */}
        <select
          value={editData.label || ""}
          className="form-select mb-2"
          onChange={(e) =>
            setEditData((prev) => ({ ...prev, label: e.target.value }))
          }
        >
          <option value="">Select Priority</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>

    {/* Assignees */}
<Select
  options={assignees} // full list of assignees
  isMulti
  closeMenuOnSelect={false}
  value={selectedAssignees} // will contain preselected ones after handleEdit runs
  onChange={(options) => setSelectedAssignees(options || [])}
  className="basic-multi-select mb-2"
  classNamePrefix="select"
  placeholder="Select assignees"
/>




          <DatePicker
  selected={editData.deadline ? new Date(editData.deadline) : null}
  onChange={(date) =>
    setEditData((prev) => ({ ...prev, deadline: date }))
  }
  className="form-control mb-2 w-100"
  dateFormat="yyyy-MM-dd"
  placeholderText="Select deadline"
/>


          <button className="btn btn-primary tab5" onClick={() => handleSaveEdit(index)}>Save edit</button>
        </div>
      );
    }




const handleChangeStatus = async (projectId, newStatus) => {
  try {
    // Update local state first for instant UI feedback
    const updatedProjects = projects.map((project) =>
      project.id === projectId ? { ...project, status: newStatus } : project
    );

    // Reorder items in the new status column
    const reorderedList = updatedProjects
      .filter((p) => p.status === newStatus)
      .sort((a, b) => a.id - b.id); // Optional sorting (or keep as-is)

    const payload = {
      status: newStatus,
      projects: reorderedList.map((item) => ({ id: item.id })),
    };

    setProjects(updatedProjects); // Update state immediately

    await axios.post(`${baseurl}updateProjectStatus`, payload); // Send to backend

    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Project updated successfully',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      background: '#28a745',
      color: '#fff'
    });

  } catch (error) {
    console.error('Failed to update status/order:', error);
    alert('Status update failed. Try again.');
  }
};





    return (
      <div>
        <div
          key={index}
          className={`card p-2 mb-2 shadow-sm position-relative  pcard ${darkMode ? "dark" : ""} `}
        >
          <Link className="" to={`/user-project-detail/${project.id}/${slugify(project.title, {
                lower: true,
                strict: true,
              })}`}>
            {/* <div className="css-1me4fbs me-2">
              <img src={p1} className="img-fluid p1cls" />
            </div> */}

<div>
  <span onClick={(e) => {
    e.preventDefault();   // prevent <Link> navigation
    e.stopPropagation();  // stop bubbling to parent Link
    handleEdit(index);
  }}
    className={`${
      project.status === "done"
        ? "complete"
        : project.label === "Low"
        ? "low"
        : project.label === "Medium"
        ? "medium"
        : project.label === "High"
        ? "high"
        : "low"
    } ${darkMode ? "dark" : ""}`}
  >
   <span  className='me-1'>◉</span> 
   {project.status === "done"
      ? "Complete"
      : project.label || "Low"}
  </span>
</div>



            <Link
              to={`/user-project-detail/${project.id}/${slugify(project.title, {
                lower: true,
                strict: true,
              })}`}
              className="text-dark"
            >
              <strong className={` mainttl ${darkMode ? "dark" : ""}`}>{project.title} </strong>
              <p className={` small mb-0 mainttl ${darkMode ? "dark" : ""}`}><i>"{project.description}"</i></p>
            
            </Link>

 
 {/* Assignees */}

<hr className={`mainttl ${darkMode ? "dark" : ""} mb-2 `}/>

 <div className='d-flex justify-content-between align-items-baseline'>
  <div>
    <p className={`mainttl ${darkMode ? "dark" : ""} small mb-0`} style={{fontSize: '13px'}}
    onClick={(e) => {
    e.preventDefault();   // prevent <Link> navigation
    e.stopPropagation();  // stop bubbling to parent Link
    handleEdit(index);
  }}
    >
      <Calendar className='me-2'/>
  {project.deadline
    ? new Date(project.deadline).toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
        year: "2-digit"
      })
    : " "}
</p>
</div> 
  <div>
    <div className="d-flex gap-1 mt-2 ms-2" onClick={(e) => {
    e.preventDefault();   // prevent <Link> navigation
    e.stopPropagation();  // stop bubbling to parent Link
    handleEdit(index);
  }}>
    {project.assignees_info && project.assignees_info.length > 0 ? (
      <>
        {project.assignees_info.slice(0, 7).map((a, index) => {
          const initials = a.full_name
            .split(' ')
            .map(word => word.charAt(0).toUpperCase())
            .join('')
            .slice(0, 2);

          const colors = [
            'rgb(220, 53, 69)',
            'rgb(255, 193, 7)',
            'rgb(111, 66, 193)',
            'rgb(102, 16, 242)',
            'rgb(25, 135, 84)',
            'rgb(13, 110, 253)',
            'rgb(255, 87, 34)'
          ];

          const bgColor = colors[index % colors.length];

          return (
            <div
              key={a.id}
              className="rounded-circle text-white d-flex align-items-center justify-content-center"
              title={`${a.full_name} (${a.role})`}
              style={{
                width: '30px',
                height: '30px',
                fontSize: '0.75rem',
                fontWeight: 600,
                marginLeft: '-10px',
                border: '1px solid #fff',
                backgroundColor: bgColor
              }}
            >
              {initials}
            </div>
          );
        })}

        {project.assignees_info.length > 7 && (
          <div
            className="rounded-circle text-white d-flex align-items-center justify-content-center"
            style={{
              width: '30px',
              height: '30px',
              fontSize: '0.75rem',
              fontWeight: 600,
              marginLeft: '-10px',
              border: '1px solid #fff',
              backgroundColor: 'gray'
            }}  
            title={`${project.assignees_info.length - 7} more`}
          >
            +{project.assignees_info.length - 7}
          </div>
        )}
      </>
    ) : (
      <span className="text-muted"></span>
    )}
  </div>
  </div>
 </div>
  




          </Link>

          <div className="dropdown position-absolute end-0 top-0 mt-2 me-2">
            <button className="btn btn-sm btn-light" data-bs-toggle="dropdown">
              <i className="bi bi-three-dots-vertical"></i>
            </button>
            <ul className="dropdown-menu">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => handleEdit(index)}
                >
                  Edit
                </button>
              </li>

              {project.status !== "todo" && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleChangeStatus(project.id, "todo")}
                  >
                    Move to To Do
                  </button>
                </li>
              )}

              {project.status !== "progress" && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleChangeStatus(project.id, "progress")}
                  >
                    Move to In Progress
                  </button>
                </li>
              )}

              {project.status !== "done" && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleChangeStatus(project.id, "done")}
                  >
                    Move to Done
                  </button>
                </li>
              )}

              {project.status !== "closed" && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleChangeStatus(project.id, "closed")}
                  >
                    Close Project
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const statusMap = {
  'To Do': 'todo',
  'In Progress': 'progress',
  'In-Review': 'in_review',
  'Done': 'done',
  'Closed': 'closed',
};

const columnsToRender = showClosed
  ? ['To Do', 'In Progress', 'In-Review', 'Done', 'Closed']
  : ['To Do', 'In Progress', 'In-Review', 'Done'];

const [searchTerm, setSearchTerm] = useState('');



// Add state for filter
const [priorityFilter, setPriorityFilter] = useState("");

// Handler to update filter
const handleFilterChange = (e) => {
  setPriorityFilter(e.target.value);
};

const [role, setRole] = useState("");
const assignee_id = localStorage.getItem("assignee_id");

// ✅ Fetch role and store org_id & user_id
  useEffect(() => {
    const fetchRole = async () => {
      if (!assignee_id) {
        Swal.fire("Error", "Assignee ID not found in local storage", "error");
        return;
      }

      try {
        const res = await axios.get(`${baseurl}getAssigneeRoleById/${assignee_id}`);
        if (res.data.success) {
          const { role, org_id, user_id } = res.data;
          setRole(role);
          localStorage.setItem("user_org_id", org_id);
          localStorage.setItem("assignee_user_id", user_id);
        } else {
          Swal.fire("Error", res.data.message || "Failed to fetch role", "error");
        }
      } catch (err) {
        console.error("Error fetching assignee role:", err);
        Swal.fire("Error", "Server error while fetching role", "error");
      }
    };

    fetchRole();
  }, [assignee_id]);



  return (
    <div className={`container-fluid cont1 bg-white-bg1 ${darkMode ? "dark" : ""}`}>
      {/* <div className="d-flex justify-content-between align-items-center">
        <h4>Product Management</h4>
        <button
          className="btn new-project-btn d-flex align-items-center gap-1 px-3 py-2 tab5 text-white"
          onClick={() => setShowClosed(!showClosed)}
        >
          <i className="bi bi-eye-slash"></i>{" "}
          {showClosed ? "Hide Closed Projects" : "Show Closed Projects"}
        </button>
      </div> */}


<div className='d-flex justify-content-between '>
  <div className="mb-2" style={{ maxWidth: "400px", position: "relative" }}>
  <Search 
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#888",
      pointerEvents: "none"
    }}
  />
  <input
    type="text"
    className={`inputsearch ${darkMode ? "dark" : ""}`}
    placeholder="Search Projects..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
    style={{ paddingLeft: "35px" }} // leave space for icon
  />
</div>

<div className="d-flex justify-content-end align-items-center mb-2">
  {/* <Filter size={18} className="me-2 text-muted" /> */}
<Select
  options={options}
  value={options.find((o) => o.value === priorityFilter)}
  onChange={(selected) => setPriorityFilter(selected.value)}
  className="w-auto"
  placeholder={<><Filter size={15} className="me-1" /> Filter by priority</>}
/>
</div>


</div>


 <UserTabMenu/>


{(role === "Manager" || role === "Owner") && (
       <div className="d-flex justify-content-between align-items-center mt-1">
       <div></div>
        <button
          className={`btn new-project-btn d-flex align-items-center gap-1 px-3 py-2 tab4 mainttl ${darkMode ? "dark" : ""} `}
          onClick={() => setShowForm(!showForm)}
        >
          <i className="bi bi-plus"></i>{" "}
          {showForm ? "Hide Form" : "Add Project"}
        </button>

        
      </div>
      )}

      

      






      <DragDropContext
        onDragEnd={async (result) => {
          const { destination, source, draggableId } = result;

          if (
            !destination ||
            (destination.droppableId === source.droppableId &&
              destination.index === source.index)
          ) {
            return;
          }

          const projectId = parseInt(draggableId);
          const sourceStatus = statusMap[source.droppableId];
          const destinationStatus = statusMap[destination.droppableId];

          // Separate into buckets by status
          const updatedByStatus = {};
          for (const statusKey of Object.values(statusMap)) {
            updatedByStatus[statusKey] = [];
          }

          projects.forEach((p) => {
            const currentStatus =
              p.id === projectId ? destinationStatus : p.status;

            if (!updatedByStatus[currentStatus]) {
              console.warn(
                `Unknown status: ${currentStatus} — skipping project ID ${p.id}`
              );
              return;
            }

            const updatedProject =
              p.id === projectId ? { ...p, status: destinationStatus } : p;
            updatedByStatus[currentStatus].push(updatedProject);
          });

          // Reorder destination list
          const draggedProject = updatedByStatus[destinationStatus].find(
            (p) => p.id === projectId
          );
          updatedByStatus[destinationStatus] = updatedByStatus[
            destinationStatus
          ].filter((p) => p.id !== projectId);
          updatedByStatus[destinationStatus].splice(
            destination.index,
            0,
            draggedProject
          );

          // Flatten back to single list preserving other columns' order
          const newProjectList = [];
          for (const statusKey of Object.values(statusMap)) {
            updatedByStatus[statusKey].forEach((item, idx) => {
              newProjectList.push({ ...item, display_order: idx }); // Update local order
            });
          }

          setProjects(newProjectList); // Instantly reflect UI

          // Send updated order for destination status only
          const reorderedPayload = updatedByStatus[destinationStatus].map(
            (item, idx) => ({
              id: item.id,
              status: destinationStatus,
              display_order: idx,
            })
          );

          try {
            await axios.post(`${baseurl}updateProjectStatus`, {
              projects: reorderedPayload,
            });
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Project Moved successfully",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              background: "#28a745",
              color: "#fff",
            });
          } catch (error) {
            console.error("Status/order update failed:", error);
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: "Failed to update project status/order.",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              background: "#dc3545",
              color: "#fff",
            });
          }
        }}
      >
        <div className="row mt-2 g-2">
          {columnsToRender.map((column) => (
            <div key={column} className={showClosed ? "col" : "col-md-3"}>
              <h6
                className={`crdf2 ${darkMode ? "dark" : ""} opbgn`}
                style={{
                  backgroundColor: columnColors[column],
                }}
              >
                {column}
              </h6>

              <div
                className={`crdf2 ${darkMode ? "dark" : ""}`}
                style={{
                  backgroundColor: columnColors[column],
                  padding: "10px",
                  borderRadius: "8px",
                }}
              >
                {/* Create Project Form (only in "To Do" column) */}
                {column === "To Do" && showForm && (
                  <div className="card-form p-1 shadow-sm bdclm bg-light mb-3">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Project Title"
                      value={newProject.title}
                      onChange={(e) =>
                        setNewProject({ ...newProject, title: e.target.value })
                      }
                    />

                    <textarea
                      className="form-control mb-2"
                      placeholder="Project Description"
                      rows="3"
                      value={newProject.description}
                      onChange={(e) =>
                        setNewProject({
                          ...newProject,
                          description: e.target.value,
                        })
                      }
                    ></textarea>

                    <select
                      value={newProject.label}
                      className="form-select mb-2"
                      onChange={(e) =>
                        setNewProject({
                          ...newProject,
                          label: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Priority</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </select>

                    <Select
                      options={assignees}
                      isMulti
                      closeMenuOnSelect={false}
                      value={selectedAssignees}
                      onChange={handleAssigneeChange}
                      className="basic-multi-select mb-2"
                      classNamePrefix="select"
                      placeholder="Select assignees"
                    />

                    <DatePicker
                      selected={newProject.deadline}
                      onChange={(date) =>
                        setNewProject({ ...newProject, deadline: date })
                      }
                      className="form-control mb-2 w-100"
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select deadline"
                    />

                    <button
                      className="btn btn-primary tab5 w-100"
                      onClick={handleCreate}
                    >
                      Create Project
                    </button>
                  </div>
                )}

                <Droppable droppableId={column}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{ minHeight: "100px" }}
                    >
                      {projects
                        .map((p, idx) => ({ ...p, idx }))
                        .filter(
                          (p) =>
                            p.status === statusMap[column] &&
                            (p.title.toLowerCase().includes(searchTerm) ||
                              p.description
                                ?.toLowerCase()
                                .includes(searchTerm)) &&
                            (priorityFilter === "" || p.label === priorityFilter) // ✅ filter applied
                        )
                        .map((p, index) => (
                          <Draggable
                            key={p.id}
                            draggableId={`${p.id}`}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {renderProjectCard(p, p.idx)}
                              </div>
                            )}
                          </Draggable>
                        ))}

                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </div>
          ))}
        </div>
      </DragDropContext>

    </div>
  );
}
